import { Box, Button, Text, useDisclosure } from '@chakra-ui/react';
import { useActiveSession } from '@texas/hooks/useSession';
import { getInitials } from '@texas/utils/helpers/commonHelpers';
import { ProfileDrawer } from './ProfileDrawer';

export function NavigationProfile() {
  const session = useActiveSession();
  const disclosure = useDisclosure();

  return (
    <>
      <Button variant="navigationProfile" onClick={disclosure.onOpen}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          boxSize={7}
          borderWidth="1px"
          borderColor="whiteAlpha.400"
          fontFamily="barlow"
          fontSize="11px"
          fontWeight="bold"
        >
          {getInitials(session.currentUser.name)}
        </Box>
        <Text maxW={16} fontSize="11px" fontWeight="normal" noOfLines={1}>
          {session.currentUser.name.split(' ')[0]}
        </Text>
      </Button>
      <ProfileDrawer isOpen={disclosure.isOpen} onClose={disclosure.onClose} />
    </>
  );
}
